<template>
  <v-container class="d-flex align-center justify-center" style="min-height: 80vh;">
    <v-col cols="12" sm="8" md="6" lg="4">
      <v-card elevation="2" rounded="lg" class="pa-2">
        <v-card-title class="text-h5 text-center pt-4">Verificare Cod Securitate</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="username"
              label="Username"
              prepend-inner-icon="mdi-account"
              variant="outlined"
              density="compact"
              disabled
              class="mb-2"
            />
            <v-text-field
              v-model="security_code"
              type="text"
              label="Cod de Securitate"
              prepend-inner-icon="mdi-shield-key"
              variant="outlined"
              density="compact"
              required
              :rules="inputRulesSecurityCode"
              @keyup.enter="loginLevel2"
            />
            <v-alert
              v-if="error"
              type="error"
              density="compact"
              class="mt-2 mb-3"
              closable
              @click:close="error = false"
            >
              Cod de securitate invalid.
            </v-alert>
            <v-btn
              :disabled="!valid"
              color="primary"
              variant="flat"
              block
              size="large"
              :loading="loading"
              @click="loginLevel2"
            >
              Login
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-container>
</template>

<script>
import {log} from "@/composables/useLog";
import {BASE_URL} from "@/composables/url_config";
import axios from "axios";

export default {
  data() {
    return {
      error: false,
      valid: true,
      loading: false,
      security_code: "",
      username: "",
      inputRulesSecurityCode: [
        v => !!v || 'Acest camp este obligatoriu',
        v => v.length >= 4 || 'Minim 4 caractere'
      ]
    }
  },
  props: ["currentUsername"],
  created() {
    log("LoginLevel2 created, currentUsername:" + this.currentUsername);
    this.username = this.currentUsername;
  },
  methods: {
    async loginLevel2() {
      const url = BASE_URL + '/home/loginLevel2';
      this.loading = true;
      try {
        const response = await axios.post(url, {
          username: this.currentUsername,
          security_code: this.security_code,
        });
        if (response.data.error) {
          this.error = true;
        } else {
          log("loginLevel2 success");
          this.$emit("goToDashboard", response.data);
        }
      } catch {
        this.error = true;
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
